<template>
  <div>
<b-container class="side-n"  >
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('general')" block squared id="bgeneral" class=" btn-color btn-color-active">
        General FAQ
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('mybijulee')" block squared id="bmybijulee" class=" btn-color">
      FAQ About My Bijulee App
    </b-button></b-col>
  </b-row>

</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
    goto(refName) {
       var element=document.getElementById(refName);
       var btn_id='b' + refName;
       var btn=document.getElementById(btn_id);
       element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });
       document.querySelector(".btn-color-active").classList.remove("btn-color-active");
       btn.classList.add("btn-color-active");
     }
   }
  }

</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;
 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd;
  border-color: #0277bd;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1;
  border-color: #0288d1;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
